// Generated file : do not modify
import Owner from '@/extend/classes/Owner';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Abonnements
export default class Subscription  {
  // Identifiant unique
  public id: number;
  // Type d'abonnement
  public subscriptionTypeId: number;
  // Date de debut de l'abonnement
  public dateDebut: Date;
  // Date de fin du préavis
  public finPreavis: Date | null;
  // Date de résiliation effective
  public dateResiliation: Date | null;
  // Derniere facture
  public lastBilled: Date | null;
  // Résiliation prélude
  public resiliationPrelude: boolean;
  // Owner
  public owner: Owner;
  // Moyen de paiement de l'abonnement
  public aboMeansId: number;
  // Frais min négociés
  public minTraitement: number | null;
  // Frais max négociés
  public maxTraitement: number | null;
  // Taux frais négocié
  public tauxTraitement: number | null;
  // Début frais négociés
  public debutRemise: Date | null;
  // Fin frais négociés
  public finRemise: Date | null;
  // Nombre de paies utilisées
  public nbPaiesUsed: number;
  // Changement automatique
  public auto: boolean;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;
  // Type
  public ownerType: number;
  // Identifiant
  public ownerId: number;
  // Nom
  public ownerLabel: string;

  constructor() {
    this.id = 0;
    this.subscriptionTypeId = 0;
    this.dateDebut = new Date(1901,1,1,0,0,0,0);
    this.finPreavis = null;
    this.dateResiliation = null;
    this.lastBilled = null;
    this.resiliationPrelude = false;
    this.owner = new Owner();
    this.aboMeansId = 0;
    this.minTraitement = null;
    this.maxTraitement = null;
    this.tauxTraitement = null;
    this.debutRemise = null;
    this.finRemise = null;
    this.nbPaiesUsed = 0;
    this.auto = false;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
    this.ownerType = 0;
    this.ownerId = 0;
    this.ownerLabel = '';
  }

  public static fromJson (obj: Subscription): Subscription {
    const newSubscription: Subscription = new Subscription();
    newSubscription.id = obj.id;
    newSubscription.subscriptionTypeId = obj.subscriptionTypeId;
    newSubscription.dateDebut = new Date(obj.dateDebut);
    newSubscription.finPreavis = obj.finPreavis ? new Date(obj.finPreavis) : null;
    newSubscription.dateResiliation = obj.dateResiliation ? new Date(obj.dateResiliation) : null;
    newSubscription.lastBilled = obj.lastBilled ? new Date(obj.lastBilled) : null;
    newSubscription.resiliationPrelude = obj.resiliationPrelude;
    newSubscription.owner = JSON.parse(JSON.stringify(obj.owner));
    newSubscription.aboMeansId = obj.aboMeansId;
    newSubscription.minTraitement = obj.minTraitement;
    newSubscription.maxTraitement = obj.maxTraitement;
    newSubscription.tauxTraitement = obj.tauxTraitement;
    newSubscription.debutRemise = obj.debutRemise ? new Date(obj.debutRemise) : null;
    newSubscription.finRemise = obj.finRemise ? new Date(obj.finRemise) : null;
    newSubscription.nbPaiesUsed = obj.nbPaiesUsed;
    newSubscription.auto = obj.auto;
    newSubscription.createId = obj.createId;
    newSubscription.failed = obj.failed;
    newSubscription.canUpdate = obj.canUpdate;
    newSubscription.canDelete = obj.canDelete;
    newSubscription.display = obj.display;
    newSubscription.notifDefType = obj.notifDefType;
    newSubscription.ownerType = obj.ownerType;
    newSubscription.ownerId = obj.ownerId;
    newSubscription.ownerLabel = obj.ownerLabel;
    return newSubscription;
  }

  public toJsonSubscription (): string {
    const json = {
      subscriptionTypeId: this.subscriptionTypeId,
      dateDebut: this.dateDebut ? new Date (this.dateDebut).toString() : this.dateDebut,
      finPreavis: this.finPreavis ? new Date (this.finPreavis).toString() : this.finPreavis,
      dateResiliation: this.dateResiliation ? new Date (this.dateResiliation).toString() : this.dateResiliation,
      lastBilled: this.lastBilled ? new Date (this.lastBilled).toString() : this.lastBilled,
      resiliationPrelude: this.resiliationPrelude,
      owner: this.owner,
      aboMeansId: this.aboMeansId,
      minTraitement: this.minTraitement,
      maxTraitement: this.maxTraitement,
      tauxTraitement: this.tauxTraitement,
      debutRemise: this.debutRemise ? new Date (this.debutRemise).toString() : this.debutRemise,
      finRemise: this.finRemise ? new Date (this.finRemise).toString() : this.finRemise,
      nbPaiesUsed: this.nbPaiesUsed,
      auto: this.auto,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromSubscription (obj: Subscription): void {
    this.id = obj.id;
    this.subscriptionTypeId = obj.subscriptionTypeId;
    this.dateDebut = new Date(obj.dateDebut);
    this.finPreavis = obj.finPreavis;
    this.dateResiliation = obj.dateResiliation;
    this.lastBilled = obj.lastBilled;
    this.resiliationPrelude = obj.resiliationPrelude;
    this.owner = obj.owner;
    this.aboMeansId = obj.aboMeansId;
    this.minTraitement = obj.minTraitement;
    this.maxTraitement = obj.maxTraitement;
    this.tauxTraitement = obj.tauxTraitement;
    this.debutRemise = obj.debutRemise;
    this.finRemise = obj.finRemise;
    this.nbPaiesUsed = obj.nbPaiesUsed;
    this.auto = obj.auto;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
    this.ownerType = obj.ownerType;
    this.ownerId = obj.ownerId;
    this.ownerLabel = obj.ownerLabel;
  }

  public compareSubscription (value: Subscription): boolean {
    return (this.toJsonSubscription() == value.toJsonSubscription());
  }

  public cloneSubscription (): Subscription {
    return Subscription.fromJson(this);
  }

  public updateForStoreSubscription (): Promise<Subscription> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/subscriptions/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromSubscription(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public createForStoreSubscription (): Promise<Subscription> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/subscriptions/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromSubscription(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/subscriptions/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static cancel (subscription: Subscription): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/subscriptions/cancel', subscription, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Subscriptions/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Subscription.fromJson(listData.reccords[0] as Subscription);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Subscription> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Subscriptions/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Subscription.fromJson(listData.reccords[0] as Subscription);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(subscriptions: Subscription[]) {
    subscriptions.forEach((item) => {
      item.dateDebut = item.dateDebut ? new Date(item.dateDebut) : item.dateDebut;
      item.finPreavis = item.finPreavis ? new Date(item.finPreavis) : item.finPreavis;
      item.dateResiliation = item.dateResiliation ? new Date(item.dateResiliation) : item.dateResiliation;
      item.lastBilled = item.lastBilled ? new Date(item.lastBilled) : item.lastBilled;
      item.debutRemise = item.debutRemise ? new Date(item.debutRemise) : item.debutRemise;
      item.finRemise = item.finRemise ? new Date(item.finRemise) : item.finRemise;
    })
  }
}
